import { Suspense } from "react";

import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { LANGUAGE_ID } from "../../../../shared/lang/lang.constants";

import { CfLoader } from "../../../../shared/components/common/CfLoader/CfLoader";
import { BaseContainer } from "../../../../shared/containers/BaseContainer/BaseContainer";
import { usePageTitle } from "../../../../shared/hooks/usePageTitle";
import Signup from "../Signup/Signup";

type Props = {
  langId: LANGUAGE_ID;
};

const SignupWrapper = (props: Props) => {
  const intl = useIntl();
  const navigate = useNavigate();

  usePageTitle(intl.formatMessage({ id: "Login.dont-have-account-register" }));

  // Create a history-like object for the class component
  const history = {
    push: (path: string) => navigate(path),
  } as { push: (path: string) => void };

  return (
    <BaseContainer>
      <Suspense fallback={<CfLoader />}>
        <Signup {...props} history={history} />
      </Suspense>
    </BaseContainer>
  );
};

export { SignupWrapper };
